<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th(width="10%")
          span(:title="$t('ui.category')") {{ $t('ui.category') }}
        th.text-right(width="10%")
          span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
        th.text-right(width="15%")
          span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(colspan="3").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td
          span(:title="item.category") {{ item.category }}&nbsp;
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.winlose, true)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
      tr.footer
        td.text-right
          span {{ $t("ui.sub_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnover)" :title="$n(subTotalValidTurnover, 'currency')") {{ $n(subTotalValidTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLose)" :title="$n(subTotalWinLose, 'currency')") {{ $n(subTotalWinLose, 'currency') }}
      tr.footer
        td.text-right
          span {{ $t("ui.grand_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    totalTbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    subTotalValidTurnover: 0,
    grandTotalValidTurnover: 0,
    subTotalWinLose: 0,
    grandTotalWinLose: 0,
  }),
  watch: {
    tbl(newValue, oldValue) {
      this.getTotal();
    },
  },
  mounted: function() {
    this.getTotal();
  },
  methods: {
    clearTotal() {
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        tbl.forEach(value => {
          this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
          this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
        });

        var totalTbl = this.totalTbl;
        if(totalTbl.length > 0) {
          this.grandTotalValidTurnover = totalTbl[0]["valid_turnover"];
          this.grandTotalWinLose = totalTbl[0]["winlose"];
        }
      }
    }
  }
};
</script>
